import "./utils/consoleCredit.js";

import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";
import store from "./store";
import {
  applyThemeToDocument,
  applyThemeToVuetify,
  getStoredPreferences,
  savePreferences,
} from "./utils/themePreferences.js";
import { Amplify } from "aws-amplify";
import VueApexCharts from "vue3-apexcharts";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import StatusChip from "@/components/Extras/StatusChip.vue";
import SwDataTable from "@/components/Extras/SwDataTable.vue";
import PageContentHeader from "@/components/Extras/PageContentHeader.vue";
import PageLayout from "@/components/Extras/PageLayout.vue";
import PageHeader from "@/components/Extras/PageHeader.vue";
import PageFilters from "@/components/Extras/PageFilters.vue";
import SwSearchField from "@/components/Extras/SwSearchField.vue";
import SwDatePicker from "@/components/Extras/SwDatePicker.vue";
import SwDatePickerField from "@/components/Extras/SwDatePickerField.vue";
import SwTimePickerField from "@/components/Extras/SwTimePickerField.vue";
import SwHeaderIconBtn from "@/components/Extras/SwHeaderIconBtn.vue";
import SwFilterBar from "@/components/Extras/SwFilterBar.vue";
import SwFilterDrawer from "@/components/Extras/SwFilterDrawer.vue";
import { FILTER_PANEL_CONTROL } from "@/constants/filterPanelControl.js";
import { showSnackbar } from "@/composables/snackbar.js";

loadFonts();
applyThemeToDocument();
savePreferences(getStoredPreferences());

async function initApp() {
  Amplify.configure({
    Auth: {
      Cognito: {
        identityPoolId: process.env.VUE_APP_IDENTITY_POOL_ID,
        userPoolId: process.env.VUE_APP_AWS_COGNITO_USER_POOL_ID,
        userPoolClientId: process.env.VUE_APP_AWS_USER_POOL_WEB_CLIENT_ID,
        authMode: "userPool",
        loginWith: {
          email: true,
        },
      },
    },
    Storage: {
      S3: {
        bucket: "servicewrkcabinet",
        region: process.env.VUE_APP_AWS_PROJECT_REGION,
      },
    },
    API: {
      GraphQL: {
        endpoint: process.env.VUE_APP_AWS_GRAPHQL_ENDPOINT,
        region: process.env.VUE_APP_AWS_PROJECT_REGION,
        defaultAuthMode: "userPool",
      },
      aws_project_region: process.env.VUE_APP_AWS_PROJECT_REGION,
      aws_appsync_graphqlEndpoint: process.env.VUE_APP_AWS_GRAPHQL_ENDPOINT,
      aws_appsync_authenticationType: "userpool",
      defaultAuthMode: "userpool",
    },
    REST: {
      razorpaypayment: {
        endpoint: process.env.VUE_APP_RAZORPAY_ENDPOINT,
      },
    },
  });
}
initApp().then(() => {
  const app = createApp(App);

  // Suppress Vue runtime warn/error console noise
  app.config.warnHandler = () => {};
  app.config.errorHandler = () => {};

  app.mixin({
    data() {
      return { FILTER_PANEL_CONTROL };
    },
  });
  app.component("StatusChip", StatusChip);
  app.component("SwDataTable", SwDataTable);
  app.component("PageContentHeader", PageContentHeader);
  app.component("PageLayout", PageLayout);
  app.component("PageHeader", PageHeader);
  app.component("PageFilters", PageFilters);
  app.component("SwSearchField", SwSearchField);
  app.component("SwDatePicker", SwDatePicker);
  app.component("SwDatePickerField", SwDatePickerField);
  app.component("SwTimePickerField", SwTimePickerField);
  app.component("SwHeaderIconBtn", SwHeaderIconBtn);
  app.component("SwFilterBar", SwFilterBar);
  app.component("SwFilterDrawer", SwFilterDrawer);
  app.config.globalProperties.$showSnackbar = showSnackbar;
  app.provide("showSnackbar", showSnackbar);
  app.use(router);
  app.use(store);
  app.use(vuetify);
  applyThemeToVuetify(vuetify);
  app.use(VueApexCharts);
  app.use(VueGoogleMaps, {
    load: {
      key: "AIzaSyAuHcsssNtWZhnt0op_n5nm9s8raGeNHGk",
      libraries: "places",
      v: "weekly",
    },
  });
  app.mount("#app");
});
